import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { NPMSMinimalRef, NpmsStore } from "../domain/npms.model";
import api from "@src/common/services/api.service";
import { ApplicationResponse } from "@src/common/domain/common.model";
import AppConstants from "@src/utils/app.constants";

export const ProjectList = createAsyncThunk<any[], void>(
  "npmsTemplate/ProjectList",
  async () => {
    const response = await api.get<any>(`${AppConstants.api}/npms/list`);
    return response.data.data || [];
  }
);

export const updateNPMSTemplateList = createAsyncThunk<
  void,
  { id: string; data: any }
>("npmsTemplate/updateNPMSTemplate", async ({ id, data }) => {
  try {
    const response = await api.put<ApplicationResponse<NPMSMinimalRef[]>>(
      `${AppConstants.api}/template/update?id=${id}`,
      data
    );

    return;
  } catch (error) {
    // return rejectWithValue(error.response?.data || error.message);
  }
});

export const addNPMSTemplateList = createAsyncThunk<void, any>(
  "npmsTemplate/addNPMSTemplate",
  async (payload: any) => {
    const response = await api.post<ApplicationResponse<NPMSMinimalRef[]>>(
      `${AppConstants.api}/template/create`,
      payload
    );
  }
);

export const npmsTemplateInfo = createAsyncThunk<any, string>(
  "npmsTemplate/ViewNPMSTemplate",
  async (id) => {
    const response = await api.get<any>(
      `${AppConstants.api}/template/info?id=${id}`
    );
    return response.data.data || {};
  }
);

export const fetchNPMSTemplateList = createAsyncThunk<any[], void>(
  "npmsTemplate/fetchNPMSTemplateList",
  async () => {
    const response = await api.get<ApplicationResponse<NPMSMinimalRef[]>>(
      `${AppConstants.api}/template/list?type=NPMS`
    );
    return response.data.data || [];
  }
);

const npmsTemplateSlice = createSlice({
  name: "npmsTemplate",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
    project: { status: "loading", error: null, data: [] },
    eventsByNpmsMinimal: { status: "loading", error: null, data: [] },

    npmsViewMinimal: { status: "loading", error: null, data: {} },
  } as NpmsStore,
  reducers: {
    resetProjectAndEventList: (state) => {
      state.project = {
        status: "loading",
        data: [],
        error: null,
      };
      state.eventsByNpmsMinimal = {
        status: "loading",
        data: [],
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNPMSTemplateList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchNPMSTemplateList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchNPMSTemplateList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(ProjectList.pending, (state, action) => {
        state.project = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(ProjectList.fulfilled, (state, action) => {
        state.project = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(ProjectList.rejected, (state, action) => {
        state.project = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })

      .addCase(npmsTemplateInfo.pending, (state, action) => {
        state.npmsViewMinimal = {
          status: "loading",
          data: {},
          error: null,
        };
      })
      .addCase(npmsTemplateInfo.fulfilled, (state, action: any) => {
        state.npmsViewMinimal = {
          status: "idle",
          data: {
            ...action.payload,
          },
          error: null,
        };
      })
      .addCase(npmsTemplateInfo.rejected, (state, action) => {
        state.npmsViewMinimal = {
          status: "failed",
          data: {},
          error: action.error,
        };
      });
  },
});
export const { resetProjectAndEventList } = npmsTemplateSlice.actions;
export default npmsTemplateSlice.reducer;
